<template>
  <!-- Decorative animated layer over the static LCP poster. aria-hidden +
       alt="" because the poster already carries the meaningful alt; this
       layer must not duplicate it for screen readers. Mounted by
       RoomSelection only on mobile AFTER the LCP window (HERO_MOUNT_DELAY_MS),
       so its <img> loads and transforms never disturb LCP measurement. -->
  <div class="hero-mslideshow absolute inset-0 overflow-hidden" aria-hidden="true">
    <img
      v-for="(slide, i) in slides"
      :key="slide.src"
      :src="slide.src"
      alt=""
      loading="lazy"
      decoding="async"
      class="hero-mslide absolute inset-0 h-full w-full object-cover"
      :class="{ 'hero-mslide--active': i === active }"
    >
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import { HERO_SLIDES, HERO_SLIDE_INTERVAL_MS, nextSlide } from "~/utils/heroSlideshow";

const slides = HERO_SLIDES;
const active = ref(0);
let timer: ReturnType<typeof setInterval> | null = null;

function start() {
  if (timer) return;
  timer = setInterval(() => {
    active.value = nextSlide(active.value, slides.length);
  }, HERO_SLIDE_INTERVAL_MS);
}
function stop() {
  if (timer) { clearInterval(timer); timer = null; }
}
function onVisibility() {
  if (document.hidden) stop(); else start();
}

onMounted(() => {
  start();
  document.addEventListener("visibilitychange", onVisibility);
});
onBeforeUnmount(() => {
  stop();
  document.removeEventListener("visibilitychange", onVisibility);
});
</script>

<style scoped>
.hero-mslide {
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
  will-change: opacity, transform;
}
.hero-mslide--active {
  opacity: 1;
  /* Ken Burns: slow zoom + drift. Runs only on the post-LCP layer. */
  animation: hero-kenburns 8s ease-out forwards;
}
@keyframes hero-kenburns {
  from { transform: scale(1) translate3d(0, 0, 0); }
  to   { transform: scale(1.08) translate3d(-1.5%, -1%, 0); }
}
@media (prefers-reduced-motion: reduce) {
  .hero-mslide { transition: none; animation: none; }
}
</style>
